// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssignedResource  {
    _originalTypeClassName = "Loom.BO.AssignedResource";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssignedResource.translate = translateService;
}
this.MonthAllocations = [];
this.Id = null;
this.AllocatedEffortPercentage = null;
this.Cost = null;
this.AllocatedEffortDays = null;
this.AllocatedEffortHours = null;
this.WorkableDays = null;
this.EmployeeCaption = null;
this.HourlyRate = null;
this.PMRate = null;
this.IsPartOfTheProjectTeam = false;
this.IsRequiredPartOfTheProjectTeam = false;
this.TotalEmployeeCostsForPlansPeriod = null;
this.WorkableHoursForPlansPeriod = null;
this.WorkableDaysForPlansPeriod = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
AllocatedEffortPercentage:any;
Cost:any;
AllocatedEffortDays:any;
AllocatedEffortHours:any;
WorkableDays:any;
EmployeeCaption:any;
HourlyRate:any;
PMRate:any;
IsPartOfTheProjectTeam:any;
IsRequiredPartOfTheProjectTeam:any;
TotalEmployeeCostsForPlansPeriod:any;
WorkableHoursForPlansPeriod:any;
WorkableDaysForPlansPeriod:any;
Project:any;
Employee:any;
MonthAllocations:any;
PlanPerProjectCostSummary:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setMonthAllocations = ($this, items) => {
                if (items == null) items = [];
                if ($this.MonthAllocations == null) $this.MonthAllocations = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MonthAllocations.length > 0) {
                    Domain.AssignedResource.removeMonthAllocations($this, $this.MonthAllocations[0]);
                }

                Domain.AssignedResource.addManyMonthAllocations($this, copyItems);
            }
static addManyMonthAllocations = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssignedResource.addMonthAllocations($this, items[i]);
                }
            }
static addMonthAllocations = ($this, item) => {
                if ($this.MonthAllocations == null) $this.MonthAllocations = [];
                if (item == null || $this.MonthAllocations.indexOf(item) > -1) return;
                $this.MonthAllocations.push(item);
if (item.AssignedResource != $this) {
Domain.AssignedResourceMonthAllocation.setAssignedResource(item, $this);
}
}
static addRangeMonthAllocations = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssignedResource.addMonthAllocations($this, item));
            }
static removeMonthAllocations = ($this, item) => {
                if ($this == null || $this.MonthAllocations == null || $this.MonthAllocations.indexOf(item) === -1) return;
                var _index = $this.MonthAllocations.indexOf(item);
                $this.MonthAllocations.splice(_index, 1);
item.AssignedResource = null;
}
static clearMonthAllocations = ($this) => { $this.MonthAllocations = null; }
static setPlanPerProjectCostSummary = ($this, value) => {
var oldValue = $this.PlanPerProjectCostSummary;
$this.PlanPerProjectCostSummary = value;
if (value != null) {
if (oldValue != null) {
Domain.PlanPerProjectCostSummary.removeAssignedResources(oldValue, $this);
}
Domain.PlanPerProjectCostSummary.addAssignedResources(value, $this);
}
}

static CalculateCost($this: any): any{$this.AllocatedEffortHours = Domain.AssignedResource.GetAllocatedEffortHours($this);
$this.AllocatedEffortDays = Domain.AssignedResource.GetAllocatedEffortDays($this);
$this.AllocatedEffortPercentage = Domain.AssignedResource.GetAllocatedEffortPercentage($this);
$this.Cost = Joove.Common.safeNumber($this?.AllocatedEffortHours) * Joove.Common.safeNumber($this?.HourlyRate);
}
static GetAllocatedEffortDays($this: any): any{return Joove.Common.safeNumber($this?.AllocatedEffortHours) / Joove.Common.safeNumber(8.0);
}
static GetAllocatedEffortHours($this: any): any{return $this?.MonthAllocations?.linq?.sum((a) => a?.AllocatedHours);
}
static GetAllocatedEffortPercentage($this: any): any{return Joove.Common.safeNumber($this?.AllocatedEffortHours) / Joove.Common.safeNumber($this?.WorkableHoursForPlansPeriod);
}
static GetEmployeeCaption($this: any): any{Domain.AssignedResource.CalculateCost($this);
return "<b>" + $this?.Employee?.EmployeeAndOrg + "</b>" + "<br/>Utilized: " + numeral((Joove.Common.safeNumber($this?.AllocatedEffortPercentage) * Joove.Common.safeNumber(100))).format("0.00%") + "<br/>Total Cost: " + numeral($this?.Cost).format("#,##0.00€") + "<br/>Rate: " + numeral($this?.PMRate).format("#,##0.00€");
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}